import React, {Component} from 'react';
import {Container, Spinner, Table} from "reactstrap";
import AppActions from './../actions/AppActions';
import {get} from './../lib/http';
import Pager from "./Pager";
import {Link} from "react-router-dom";
import _ from 'lodash';
import BoundSelect from "./forms/BoundSelect";
import fetchLookups from "../lib/fetchLookups";

const pageSize = 20;

export class HealthAndSafety extends Component {
    componentWillMount() {
        const {skip} = this.props;

        this.update(skip || 0);
    }

    render() {
        const {items, total, skip, lookups, searchParams} = this.props;

        const rows = _.map(items, item => <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.siteName}</td>
            <td>{item.siteType}</td>
            <td>{item.siteLatitude}</td>
            <td>{item.siteLongitude}</td>
            <td>{item.region}</td>
            <td>{item.hazards}</td>
            <td>{item.incidentType}</td>
            <td>{String(item.isInjury)}</td>
            <td>{item.incidentRiskRating}</td>
            <td>{item.activityTaskInvolved}</td>
            <td>{item.consequenceDescription}</td>
            <td>{item.consequence}</td>
            <td>{item.incidentCategory}</td>
            <td>{item.incidentSubCategory}</td>
            <td>{item.incidentLevel}</td>
            <td>{item.injuryType}</td>
            <td>{item.injuryTypeShort}</td>
            <td>{item.injuryBodyPart}</td>
            <td>{item.injuryConsequence}</td>
            <td>{item.incidentCount}</td>
            <td>{item.injuryCount}</td>
            <td>{item.incidentDate}</td>
            <td>{item.reportedDate}</td>
            <td>{item.actualDate}</td>
            <td>
                <Link className="float-right" to={`incident/${item.id}`}>Edit</Link>
            </td>
        </tr>);

        const filterRow = <tr>
            <td/>
            <td>{this.renderLookup('siteName')}</td>
            <td>{this.renderLookup('siteType')}</td>
            <td/>
            <td/>
            <td>{this.renderLookup('region')}</td>
            <td>{this.renderLookup('hazards')}</td>
            <td>{this.renderLookup('incidentType')}</td>
            <td>{this.renderLookup('isInjury')}</td>
            <td>{this.renderLookup('incidentRiskRating')}</td>
            <td>{this.renderLookup('activityTaskInvolved')}</td>
            <td>{this.renderLookup('consequenceDescription')}</td>
            <td>{this.renderLookup('consequence')}</td>
            <td>{this.renderLookup('incidentCategory')}</td>
            <td>{this.renderLookup('incidentSubCategory')}</td>
            <td>{this.renderLookup('incidentLevel')}</td>
            <td>{this.renderLookup('injuryType')}</td>
            <td>{this.renderLookup('injuryTypeShort')}</td>
            <td>{this.renderLookup('injuryBodyPart')}</td>
            <td>{this.renderLookup('injuryConsequence')}</td>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
        </tr>;

        return (
            <Container fluid>
                <h1>Health and safety</h1>

                <Link to="/health-and-safety-data">Data import/export</Link>
                <Link to="/health-and-safety-sync" className="ml-3">Digital twin sync</Link>

                <Table size="sm" hover className="mt-3">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Site Name</th>
                        <th>Site Type</th>
                        <th>Site Latitude</th>
                        <th>Site Longitude</th>
                        <th>Region</th>
                        <th>Hazards</th>
                        <th>Incident Type</th>
                        <th>Is Injury</th>
                        <th>Incident Risk Rating</th>
                        <th>Activity Task Involved</th>
                        <th>Consequence Description</th>
                        <th>Consequence</th>
                        <th>Incident Category</th>
                        <th>Incident Sub Category</th>
                        <th>Incident Level</th>
                        <th>Injury Type</th>
                        <th>Injury Type Short</th>
                        <th>Injury Body Part</th>
                        <th>Injury Consequence</th>
                        <th>Incident Count</th>
                        <th>Injury Count</th>
                        <th>Incident Date</th>
                        <th>Reported Date</th>
                        <th>Actual Date</th>
                        <th className="btn-col">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filterRow}
                    {!items && <tr>
                        <td colSpan={26}><Spinner color="primary"/></td>
                    </tr>}
                    {rows}
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan={25}></td>
                        <td><Link className="float-right" to={'incident/_'}>New</Link></td>
                    </tr>
                    </tfoot>
                </Table>

                {items && <Pager pageSize={pageSize} total={total} skip={skip} onPageSelected={(skip) => this.update(skip)}/>}

            </Container>
        );
    }

    renderLookup(property) {
        const {lookups, skip, searchParams = {}} = this.props;

        const onSelected = newValue => {
            AppActions.updateStates([
                {statePath: `searchParams.${property}`, data: newValue}
            ]);

            setTimeout(() => {
                this.update(skip || 0);
            }, 0);
        };

        const lookupOptions = _.map(lookups && lookups[property], lookup => ({
            value: lookup,
            text: lookup
        }));

        const options = [{value: '', text: '<SELECT>'}, ...lookupOptions];

        return <BoundSelect
            path={`searchParams.${property}`}
            value={searchParams[property] || ''}
            onSelected={onSelected}
            options={options}/>;
    }

    update(skip) {
        const {lookups, searchParams = {}} = this.props;

        const mixId = window.localStorage.getItem('mixId') || '';

        AppActions.updateStates([
            {statePath: 'items', data: null}
        ]);

        get('api/incidents', {skip: skip, mixId, ...searchParams}, (data) => {
            AppActions.updateStates([
                {statePath: 'skip', data: skip || 0},
                {statePath: 'items', data: data.items},
                {statePath: 'total', data: data.total}
            ]);
        });

        if (lookups) {
            return;
        }

        fetchLookups();
    }
}